module.exports = __webpack_public_path__ + "img/knu2_gallery7.e418e997.jpg";